import { apiPaths } from '@/services/api/paths';
import { TMemberCareMemberNote, TMemberCareMemberNoteType } from '@/types/MemberCare.types';
import { api, TCustomAxiosResponse } from '..';

export const getNotesForMemberCareMember = async (
  memberId: string,
): Promise<TCustomAxiosResponse<TMemberCareMemberNote[]>> => {
  const { data: response } = await api.get<TCustomAxiosResponse<TMemberCareMemberNote[]>>(
    apiPaths.notes.forMember(memberId),
  );
  return response;
};

export const createNoteForMemberCareMember = async (
  content: string,
  createdFor: string,
  type: TMemberCareMemberNoteType,
): Promise<string> => {
  const { data } = await api.post(apiPaths.notes.root, { content, createdFor, type });

  const result = data.data;

  return result;
};

export const editNote = async (noteId: string, newContent: string): Promise<string> => {
  const { data } = await api.put(apiPaths.notes.byId(noteId), { content: newContent });

  const result = data.data;

  return result;
};

export const deleteNote = async (noteId: string): Promise<string> => {
  const { data } = await api.delete(apiPaths.notes.byId(noteId));

  const result = data.data;

  return result;
};
